import en from '../i18n/en-GB';
import type { Language } from '../types/Language';

export type TranslationKey = keyof typeof en;

export const translations = {
  en,
};

export const localeMap = {
  'en-gb': 'en',
  'en-us': 'en',
};

export const languageList: { name: string; language: Language }[] = [
  {
    language: 'en',
    name: 'english',
  },
];

const validLanguages = new Set(['en']);
export const isValidLanguage = (language: string): language is Language => validLanguages.has(language);

export default translations;
